import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
interface VotingModalButtonProps {
  readonly drop: ExtendedDrop;
  readonly onClick: () => void;
  readonly variant?: "default" | "subtle" | undefined; // Add variant prop for styling flexibility
  readonly className?: string | undefined;
  readonly children?: React.ReactNode;
}
const VotingModalButton: React.FC<VotingModalButtonProps> = t0 => {
  const $ = _c(8);
  const {
    drop,
    onClick,
    variant: t1,
    className,
    children
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const {
    canShowVote
  } = useDropInteractionRules(drop);
  if (!canShowVote) {
    return null;
  }
  let t2;
  if ($[0] !== onClick) {
    t2 = e => {
      e.stopPropagation();
      onClick();
    };
    $[0] = onClick;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClick = t2;
  const variantClasses = variant === "subtle" ? "tw-bg-white tw-border-white tw-text-black tw-font-semibold desktop-hover:hover:tw-bg-iron-300 tw-shadow-[0_0_15px_rgba(255,255,255,0.1)]" : "tw-bg-primary-500 tw-border-primary-500 tw-text-white tw-font-medium desktop-hover:hover:tw-bg-primary-600";
  const buttonClasses = `${"tw-flex tw-items-center tw-justify-center tw-gap-x-1 tw-px-3 tw-py-1.5 tw-rounded-md tw-border tw-border-solid tw-text-xs tw-whitespace-nowrap tw-transition-all tw-duration-300 tw-ease-out"} ${variantClasses} ${className ?? ""}`;
  const t3 = children ?? "Vote";
  let t4;
  if ($[2] !== t3) {
    t4 = <span className="tw-truncate">{t3}</span>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== buttonClasses || $[5] !== handleClick || $[6] !== t4) {
    t5 = <button type="button" onClick={handleClick} className={buttonClasses}>{t4}</button>;
    $[4] = buttonClasses;
    $[5] = handleClick;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default VotingModalButton;